import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useLazyGetLeadDataQuery } from "../../store/leadDetails";
import {
  useGetNotificationDetailsQuery,
  useReadNotificationsMutation,
} from "../../store/professionalNotifications";
import { setNotificationsList } from "../../store/reducers/notificationsSlice";
import { formatDate } from "../../utilities/utils";
import { XMarkIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { setLoader } from "../../store/reducers/globalLoaderSlice";
import { toast } from "react-toastify";

const Notifications = ({ setNotificationActive, notificationActive }) => {
  const [notificationsModal, setNotificationsModal] = useState(false);
  const notifications = useSelector(
    (state) => state.notificationsSlice.notificationsList
  );
  const {
    data: notificationsList,
    refetch: refetchNotificationsList,
    isSuccess: notificationsListSuccess,
  } = useGetNotificationDetailsQuery();

  const [trigger, result] = useLazyGetLeadDataQuery();

  const notificationType = {
    "Lead Matched": "Click here to access your new lead's contact information.",
  };

  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  const dispatch = useDispatch();
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const navigate = useNavigate();

  const [
    readNotification,
    { isSuccess: readNotificationSuccess, isLoading: readNotificationLoader },
  ] = useReadNotificationsMutation();

  useEffect(() => {
    if (readNotificationSuccess && !readNotificationLoader) {
      refetchNotificationsList();
    }
  }, [readNotificationSuccess]);

  useEffect(() => {
    if (notificationActive) {
      setNotificationsModal(false);
    }
  }, [notificationActive]);

  useEffect(() => {
    if (result && result.data && !result.isFetching) {
      dispatch(setLoader(false));
      if (isMobile) {
        setNotificationActive(false);
        setNotificationsModal(false);
      }
      navigate(`/dashboard/matches/${result.data.id}`, {
        state: { leadData: result.data },
      });
    } else if (result.error) {
      dispatch(setLoader(false));
      if (isMobile) {
        setNotificationActive(false);
        setNotificationsModal(false);
      }
      toast.error(result.error.data.message);
    }
  }, [result]);

  useEffect(() => {
    if (notificationActive) {
      let filterNotifications =
        notifications?.length > 0 &&
        notifications?.filter((notification) => notification.read_at === null);
      setFilteredNotifications(filterNotifications);
    }
  }, [notificationActive, notifications]);

  useEffect(() => {
    if (notificationActive && notifications && notifications.length > 0) {
      let updatedNotifications = [];
      filteredNotifications?.length &&
        filteredNotifications.forEach((filteredNotification) => {
          let found = notifications.find(
            (notification) => notification.id == filteredNotification.id
          );
          if (found) {
            updatedNotifications.push(found);
          } else {
            updatedNotifications.push(filteredNotification);
          }
        });
      setFilteredNotifications([...updatedNotifications]);
    }
  }, [notifications]);

  useEffect(() => {
    if (notificationsListSuccess) {
      dispatch(setNotificationsList(notificationsList?.data));
    }
  }, [notificationsListSuccess]);

  const getformatDate = (inputDate) => {
    const date = new Date(inputDate);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return formatDate(inputDate);
    }
  };

  const handleReadNotication = (notification) => {
    const params = {
      notification_ids: [notification.id],
    };
    readNotification(params);
    if (
      notification.type == "Lead Matched" &&
      notification?.details?.match_id
    ) {
      trigger(notification?.details?.match_id);
      dispatch(setLoader(true));
    }
  };

  // const handleMarkAllRead = () => {
  //   let notificationIds = [];
  //   notifications.forEach((notification) => {
  //     if (notification.read_at == null) {
  //       notificationIds.push(notification.id);
  //     }
  //   });
  //   if (notificationIds.length > 0) {
  //     const params = {
  //       notification_ids: notificationIds,
  //     };
  //     readNotification(params);
  //   }
  // };

  return (
    <>
      <div className="border border-solid border-[#EBEFF3] rounded-md py-5 w-[344px] bg-white shadow-[0px_14px_18px_0px_rgba(55,77,98,0.14)]">
        <div className="flex items-center justify-between gap-5 pb-5 px-5 border-b border-solid border-[#EBEFF3] sticky">
          <h5 className="text-base font-bold leading-[160%] text-customGray">
            Notifications
          </h5>
          <XMarkIcon
            className="w-6 h-6 text-customGray cursor-pointer hover:text-red-500"
            onClick={() => {
              setNotificationActive(false);
              setNotificationsModal(false);
            }}
          />
          {/* <a
          onClick={handleMarkAllRead}
          className="text-sm font-medium leading-[160%] text-primary cursor-pointer"
        >
          Mark all as read
        </a> */}
        </div>
        <div className="scroller overflow-auto max-h-[410px] bg-white scrollbar-track-bg-white">
          <ul className="notification-list">
            {filteredNotifications &&
              filteredNotifications.length > 0 &&
              filteredNotifications?.map((item) => (
                <li
                  className="px-5 border-b border-solid border-[#EBEFF3] bg-[#FFFFFF] hover:bg-[#EBF7FF] py-[14px] cursor-pointer last:border-0"
                  onClick={() => handleReadNotication(item)}
                >
                  <h6 className="text-sm font-bold leading-[160%] text-customGray mb-1 flex items-center gap-[10px]">
                    <b
                      className={`${
                        item.read_at !== null
                          ? "text-[#BEC2C5]"
                          : "text-primary"
                      } text-xl leading-[160%] -translate-y-[2px]`}
                    >
                      &#8226;
                    </b>
                    {item.title}
                  </h6>
                  <p className="text-sm font-normal leading-[160%] text-[#485868] mb-1">
                    {item.message}{" "}
                    <span className="text-primary">
                      {" "}
                      {notificationType[item.type]}
                    </span>
                  </p>
                  <span className="text-xs font-medium leading-[106%] text-customGray">
                    {getformatDate(item.created_at)}
                  </span>
                </li>
              ))}
            {(!filteredNotifications || filteredNotifications.length <= 0) && (
              <li className="border-b border-solid border-[#EBEFF3] bg-[#FFFFFF] pt-5 px-5 last:border-0">
                <h5 className="flex items-center gap-2 mb-1">
                  <CheckCircleIcon className="w-6 h-6 text-[#16CA7C]" />{" "}
                  <span className="text-sm font-bold text-customGray leading-[160%]">
                    You’re All Caught Up!
                  </span>
                </h5>
                <p className="text-sm text-[#485868] font-normal leading-[160%] pb-[14px] border-b border-[#EBEFF3]">
                  You have no new notifications
                </p>
              </li>
            )}
          </ul>

          <div className="flex items-center justify-end mt-3 mr-4">
            <Link
              onClick={() => setNotificationsModal(!notificationsModal)}
              className="text-base font-medium text-primary underline"
            >
              {notificationsModal
                ? "Hide old notifications"
                : "Show old notifications"}
            </Link>
          </div>
          {notificationsModal && (
            <ul className="notification-list">
              {notificationsList &&
                notificationsList?.data.length > 0 &&
                notificationsList?.data?.map(
                  (item) =>
                    item.read_at != null && (
                      <li
                        className="px-5 border-b border-solid border-[#EBEFF3] bg-[#FFFFFF] hover:bg-[#EBF7FF] py-[14px] cursor-pointer last:border-0"
                        onClick={() => {
                          if (
                            item.type == "Lead Matched" &&
                            item?.details?.match_id
                          ) {
                            trigger(item?.details?.match_id);
                            dispatch(setLoader(true));
                          }
                        }}
                      >
                        <h6 className="text-sm font-bold leading-[160%] text-customGray mb-1 flex items-center gap-[10px]">
                          <b
                            className={`${
                              item.read_at !== null
                                ? "text-[#BEC2C5]"
                                : "text-primary"
                            } text-xl leading-[160%] -translate-y-[2px]`}
                          >
                            &#8226;
                          </b>
                          {item.title}
                        </h6>
                        <p className="text-sm font-normal leading-[160%] text-[#485868] mb-1">
                          {item.message}{" "}
                          <span className="text-primary">
                            {" "}
                            {notificationType[item.type]}
                          </span>
                        </p>
                        <span className="text-xs font-medium leading-[106%] text-customGray">
                          {getformatDate(item.created_at)}
                        </span>
                      </li>
                    )
                )}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default Notifications;
